import { KibButtonNew } from '@chewy/kib-controls-react';
import { KibContainer } from '@chewy/kib-layout-react';
import { KibChewyPlusLogo } from '@chewy/kib-logos-react';
import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { SEGMENT_TAGS } from '@/analytics/tag-definitions';
import { useAnalyticsContext } from '@/providers/AnalyticsProvider';

import styles from './StickyFreeTrialHeader.module.scss';

// This matches the height of the desktop chewy header
const HEADER_SCROLL_THRESHOLD = 112;

interface Props {
  onButtonClick: () => void;
}

export const StickyFreeTrialHeader = ({ onButtonClick }: Props) => {
  const { t } = useTranslation();

  const [isVisible, setIsVisible] = useState(false);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth',
    });
  };
  const { trackSegmentEvent } = useAnalyticsContext();

  useEffect(() => {
    const checkScrollPosition = () => {
      const isHeaderNowVisible = window.scrollY > HEADER_SCROLL_THRESHOLD;
      setIsVisible(isHeaderNowVisible);

      if (isHeaderNowVisible) {
        trackSegmentEvent(
          SEGMENT_TAGS.ViewsStickyHeaderLandingPage.eventName,
          SEGMENT_TAGS.ViewsStickyHeaderLandingPage.data,
        );
      }
    };

    checkScrollPosition();
    window.addEventListener('scroll', checkScrollPosition);
    return () => window.removeEventListener('scroll', checkScrollPosition);
  }, [trackSegmentEvent]);

  return (
    <div
      className={clsx([styles.stickyContainer, isVisible ? styles.visible : ''])}
      data-testid="sticky-header"
    >
      <KibContainer>
        <div className={styles.grid}>
          <div
            aria-label="Chewy+"
            className={styles.logoButton}
            onClick={scrollToTop}
            onKeyDown={onButtonClick}
            role="button"
            tabIndex={0}
          >
            <KibChewyPlusLogo className={styles.chewyPlusLogo} />
          </div>
          <KibButtonNew
            emphasis="tertiary"
            onClick={() => {
              trackSegmentEvent(
                SEGMENT_TAGS.ProceedsToSignupSheet.eventName,
                SEGMENT_TAGS.ProceedsToSignupSheet.data,
              );
              onButtonClick();
            }}
          >
            <span>{t('loyalty.sign-up.try-for-free')}</span>
          </KibButtonNew>
        </div>
      </KibContainer>
    </div>
  );
};
